__turbopack_context__.v({
  "backdrop": "ConfirmDialog-module__fszRoq__backdrop",
  "content": "ConfirmDialog-module__fszRoq__content",
  "footer": "ConfirmDialog-module__fszRoq__footer",
});
